import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import './sign-in-forget-password.scss';
import signInLogo from "../../assets/header_logo.png";


const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    alignItems: 'center',
    textAlign:'center',
  },
}));

export default function SignInForgetPassword() {
  const classes = useStyles();

  return (
      <div className="sign-in-forget-password">
      
            <Container component="main" maxWidth="xs">
                    <div className={classes.paper}>
                       <img className="sign-in-img-logo" src={signInLogo} alt="singin image"/>                       
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="‏اسم المستخدم، أو عنوان البريد الإلكتروني"
                                name="email"
                                // autoComplete="email"
                                autoFocus
                            />

                           
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                            إعادة تعيين كلمة المرور  
                          </Button>
                             
                          <div className="forget-password-login">
                                <Link href="/login" variant="body2">
                                    {" لديك حساب بالفعل؟ تسجيل الدخول"}
                                </Link>
                            </div>
                            <div>
                                <Link href="/register" variant="body2">
                                    {"ليس لديك اسم مستخدم؟ تسجيل كجهة"}
                                </Link>
                            </div>
                            
                            
                            
                        
                        </form>
                    </div>
                
            </Container>
    </div>
  );
}